import React from 'react';

function SumFormater(summ) {
    let s = summ.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    return (
        <div style={{textAlign: 'right'}}>{s} s.</div>
    );
}

export default SumFormater;